module.exports = __webpack_public_path__ + "img/Stage_8_Diff.dcbf3f78.jpg";